<table cellspacing="10px">
  <tbody>
  <tr>
    <td>
      Welcome to the FS Invoice application.
    </td>
  </tr>
  <tr>
    <td>
      Today is {{ today | date:'longDate' }}
    </td>
  </tr>
  <tr *ngIf='this.homeOffices.length >0'>
    <td>
      Current Home Office: {{display}}
    </td>
  </tr>
  <tr *ngIf='this.homeOffices.length >0'>
    <td>
      <div style="padding-right: 4px">Please choose a Home Office to work with</div>
      <kendo-dropdownlist
        [data]="homeOffices"
        [textField]="'display'"
        [valueField]="'hoId'"
        [(ngModel)]="selectedHomeOffice"
        (valueChange)="homeOfficesValueChange($event)"
        name="selectedValue"
        style="width: 350px;">
      </kendo-dropdownlist>
    </td>
  </tr>
  </tbody>
</table>
<div style="visibility:hidden;">Install Verification Token 2018-12-18 10:45 AM</div>
<div kendoDialogContainer></div>
